import React from "react";
import { Booking, Color } from "../../types";
import { getStyle } from "../../utils";

export interface BookingCardStyle {
  style: React.CSSProperties;
  className: string;
}

/** Status colours plus the EOT border and open-issue marker shared by every booking card. */
export const getBookingCardStyle = (
  booking: Booking,
  colors: Color[],
): BookingCardStyle => {
  const status =
    booking.revisions?.length > 0 && booking.status === "new"
      ? "revised"
      : booking.status;

  const style: React.CSSProperties = getStyle(status, colors);

  if (booking.is_eot) {
    style.border = "1px solid red";
  }

  const hasOpenIssue = booking.allocations?.some(
    (allocation: any) =>
      (allocation.product_instance?.open_issues?.length ?? 0) > 0,
  );

  const classNames: string[] = [];
  if (booking.is_eot) classNames.push("rbc-event-eot");
  if (hasOpenIssue) classNames.push("rbc-event-has-issue");

  return { style, className: classNames.join(" ") };
};
